import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import Editor from '../../../../../components/editor/Editor';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { StepProps } from './AddEditKitchenSkill';

export const KitchenSkillForm = ({ touched, errors, values, setFieldValue, readOnly }: StepProps) => {
  return (
    <Row>
      <Col xs={12}>
        <FormStepHeader title="Kitchen Skill Details" showRequiredLegend={!readOnly} />
      </Col>
      <Col
        xs={12}
        lg={6}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="name"
        >
          <FormLabel required>Name</FormLabel>
          <Field
            name="name"
            type="text"
            as={Form.Control}
            isInvalid={touched.name && !!errors.name}
            aria-required
          />
          <ErrorMessage name="name">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>

      <Col
        xs={12}
        lg={12}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-10"
          controlId="details"
        >
          <FormLabel required>Description</FormLabel>
          <Field
            name="description"
            component={Editor}
            className="form-control"
            isInvalid={touched.description && !!errors.description}
            aria-required
          />
          <ErrorMessage name="description">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>
    </Row>
  );
};
